
'use client'

import Link from 'next/link'
import { ArrowLeft } from 'lucide-react'

export default function ResidentialPage() {
  return (
    <main className="bg-gray-500 min-h-screen py-10">
      <div className="max-w-4xl mx-auto px-4 sm:px-8">
        {/* 返回按钮 */}
        <Link
          href="/"
          className="inline-flex items-center gap-2 bg-gray-100 text-gray-900 px-3 py-1 rounded-lg mb-6 hover:bg-gray-200 transition"
        >
          <ArrowLeft className="w-4 h-4" /> Back
        </Link>

        {/* 标题 */}
        <h1 className="text-4xl md:text-5xl font-bold mb-10 text-white text-center">
          Residential Projects
        </h1>
  
        {/* 空状态卡片 */}
        <div className="bg-white p-10 rounded-lg shadow-lg">
          <p className="text-gray-700 text-lg">
            Simoom is a <strong>Queensland-based residential builder</strong> specialising in home renovations, extensions, and custom fit-outs. From initial planning and design to full construction, we deliver practical, high-quality solutions tailored to your lifestyle and needs.
            <br></br><br></br>
            Our residential services include <strong>space planning, custom joinery, interior finishes, and project management</strong>, ensuring homes are functional, stylish, and built to last.
            <br></br><br></br>
            As a local builder, we provide reliable, professional, and modern residential construction services across Queensland, helping homeowners create spaces they love.
          </p>
         <br></br>
          <p className="text-gray-800 mt-2">
            <strong>Please check back soon for updates.</strong>
          </p>
        </div>
      </div>
    </main>
  )
}




